import { render, staticRenderFns } from "./CashFlowBuyers.vue?vue&type=template&id=151898ac&scoped=true&"
import script from "./CashFlowBuyers.vue?vue&type=script&lang=js&"
export * from "./CashFlowBuyers.vue?vue&type=script&lang=js&"
import style0 from "./CashFlowBuyers.vue?vue&type=style&index=0&id=151898ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151898ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCheckbox,VContainer,VFlex,VIcon,VLayout,VTooltip})
